<my-bill-odb-page-base-structure
  [billingDocument]="billDocument"
  [hasTopContent]="true"
  [hasCommonHeader]="true"
>
  <div
    class="rs-panel-big rs-bg-c2 rs-box-shadow"
    data-cy="myBillDeferralSelectNewDatePage"
    topContent
  >
    <h2 class="rs-tit3">
      {{ 'bills.deferral.selectNewDate.mainTitle' | translate }}
    </h2>
    <div class="row">
      <div class="small-12 medium-6 columns">
        <p data-cy="myBillDeferralSelectNewDateSubtitle">
          {{ 'bills.deferral.selectNewDate.subTitle' | translate }}
        </p>
        <p data-cy="myBillDeferralTotalToPay">
          <span class="rs-font-pxB"
            >{{ 'bills.deferral.selectNewDate.totalPay' | translate }}
          </span>
          <span class="rs-price-sm">
            <span class="rs-nowrap">
              <px-currency-amount
                [amountClass]="'rs-price-m'"
                [amount]="billDocument?.amount"
              ></px-currency-amount>
            </span>
          </span>
        </p>
        <p class="rs-font-pxB" data-cy="myBillDeferralInitialDate">
          {{ 'bills.deferral.selectNewDate.initialPaymentDate' | translate
          }}<br />{{ billDocument?.dueDate }}
        </p>
      </div>
      <div class="small-12 medium-6 columns">
        <fieldset
          class="rs-form-sbox"
          data-cy="myBillDeferralSelectNewDateInputForm"
        >
          <legend class="rs-font-pxB">
            {{ 'bills.deferral.selectNewDate.selectNewDueDate' | translate }}
          </legend>
          <div
            class="rs-sbox"
            *ngFor="let dueDate of newDueDates; let i = index"
            (change)="onDateChange(dueDate.newDue)"
          >
            <input
              id="{{ 'sRadio1' + i }}"
              type="radio"
              name="date"
              autocompleted=""
              class="rs-filled"
            />
            <label for="{{ 'sRadio1' + i }}">
              <span class="rs-sbox-maincontent">
                <span class="rs-sbox-check-header">
                  <span class="rs-sbox-check"></span>
                  <span class="rs-sbox-check-content">
                    <span class="rs-sbox-title">{{
                      dueDate.stringFormatted
                    }}</span>
                  </span>
                </span>
              </span>
            </label>
          </div>
        </fieldset>
        <div class="rs-flex-row rs-flex-dir-col-small-only">
          <div class="rs-flex-column rs-order-m2">
            <a
              class="rs-btn rs-btn-next rs-btn-nl-so"
              [attr.aria-disabled]="selectedNewPaymentDate === undefined"
              tabindex="-1"
              [routerLink]="[DEFERRAL_ACCEPT_NEW_DATE]"
              [state]="{
                selectedNewPaymentDate:
                  selectedNewPaymentDate | date : 'dd/MM/yyyy'
              }"
              data-cy="myBillDeferralSelectNewDateNextButton"
              >{{ 'bills.deferral.selectNewDate.nextBtn' | translate }}
              <i class="icon-Arrowbutton rs-margin-left1" aria-hidden="true"></i
            ></a>
          </div>
          <my-bill-back-button
            [customLabel]="'bills.deferral.selectNewDate.previousBtn'"
            [backButtonType]="'firstButtonWithLeftArrow'"
          ></my-bill-back-button>
        </div>
      </div>
    </div>
  </div>
</my-bill-odb-page-base-structure>
